export const STATUSES = [
  "New", "Contacted", "Follow-Up Needed", "Scheduled", "Appointment Scheduled",
  "Completed", "Declined", "Closed", "Converted to Customer",
];

export const statusColors = {
  New: "bg-blue-600/20 text-blue-400 border-blue-500/40",
  Contacted: "bg-yellow-600/20 text-yellow-400 border-yellow-500/40",
  "Follow-Up Needed": "bg-orange-600/20 text-orange-400 border-orange-500/40",
  Scheduled: "bg-purple-600/20 text-purple-400 border-purple-500/40",
  "Appointment Scheduled": "bg-purple-600/20 text-purple-400 border-purple-500/40",
  Completed: "bg-green-600/20 text-green-400 border-green-500/40",
  Declined: "bg-red-600/20 text-red-400 border-red-500/40",
  Closed: "bg-zinc-600/20 text-zinc-400 border-zinc-500/40",
  "Converted to Customer": "bg-emerald-600/20 text-emerald-400 border-emerald-500/40",
};

export const APPT_STATUSES = ["Pending", "Scheduled", "Pending Confirmation", "Confirmed", "Reschedule Requested", "Cancellation Requested", "En Route", "On Site", "Waiting on Parts", "Completed", "Cancelled", "Rescheduled", "No-Show"];

export const apptStatusColors = {
  Pending: "bg-zinc-600/20 text-zinc-300 border-zinc-500/40",
  Scheduled: "bg-blue-600/20 text-blue-400 border-blue-500/40",
  "Pending Confirmation": "bg-amber-600/20 text-amber-300 border-amber-500/40",
  Confirmed: "bg-emerald-600/20 text-emerald-400 border-emerald-500/40",
  "Reschedule Requested": "bg-orange-600/20 text-orange-400 border-orange-500/40",
  "Cancellation Requested": "bg-red-600/20 text-red-300 border-red-500/40",
  "En Route": "bg-cyan-600/20 text-cyan-400 border-cyan-500/40",
  "On Site": "bg-amber-600/20 text-amber-400 border-amber-500/40",
  "Waiting on Parts": "bg-orange-600/20 text-orange-400 border-orange-500/40",
  Completed: "bg-green-600/20 text-green-400 border-green-500/40",
  Cancelled: "bg-zinc-600/20 text-zinc-400 border-zinc-500/40",
  Rescheduled: "bg-purple-600/20 text-purple-400 border-purple-500/40",
  "No-Show": "bg-red-600/20 text-red-400 border-red-500/40",
};

export const RECURRING_STATUSES = ["Upcoming", "Due", "Sent", "Booked", "Snoozed", "Declined", "Completed"];

export const recurringStatusColors = {
  Upcoming: "bg-blue-600/20 text-blue-400 border-blue-500/40",
  Due: "bg-amber-600/20 text-amber-400 border-amber-500/40",
  Sent: "bg-cyan-600/20 text-cyan-400 border-cyan-500/40",
  Booked: "bg-emerald-600/20 text-emerald-400 border-emerald-500/40",
  Snoozed: "bg-purple-600/20 text-purple-400 border-purple-500/40",
  Declined: "bg-red-600/20 text-red-400 border-red-500/40",
  Completed: "bg-zinc-600/20 text-zinc-400 border-zinc-500/40",
};

const GOOGLE_REVIEW_URL = "https://share.google/GkpcJx5lAmfqkljEA";

export const smsHref = (phone, msg) =>
  `sms:${(phone || "").replace(/[^+\d]/g, "")}?&body=${encodeURIComponent(msg)}`;

export const firstName = (name) => (name || "").split(" ")[0];

export const agreementLink = (leadId) =>
  leadId ? `${window.location.origin}/agree/${leadId}` : `${window.location.origin}/terms`;

export const buildScheduledSms = (first, dateH, timeH, service, agreement, booking) =>
  `Hi ${first}, your appointment with Mason's Mobile Mechanic is scheduled for ${dateH} at ${timeH} — ${service}. ` +
  `Please review and complete the service agreement before your appointment: ${agreement}.` +
  (booking ? ` To reschedule or cancel, use this link: ${booking}` : " To reschedule or cancel, call or text (404) 749-7063.");

export const buildSchedulingLinkSms = (first, booking, agreement) =>
  `Hi ${first}, thank you for contacting Mason's Mobile Mechanic. You can select an available appointment time here: ${booking}. ` +
  `Please also review our service agreement here: ${agreement}`;

export const buildRecurringSms = (first, service, booking) =>
  `Hi ${first}, it may be time to schedule your next ${service} with Mason's Mobile Mechanic.` +
  (booking ? ` You can book your next appointment here: ${booking}` : ` Call or text us at (404) 749-7063 to schedule.`);

export const reviewSmsHref = (lead) => {
  const msg = `Hi ${firstName(lead.name)}, thanks for choosing Mason's Mobile Mechanic! If you were happy with your service, would you mind leaving us a quick 5-star review? It really helps: ${GOOGLE_REVIEW_URL}`;
  return smsHref(lead.phone, msg);
};

export const termsRequestSmsHref = (lead) => {
  const msg = `Hi ${firstName(lead.name)}, before we confirm your appointment with Mason's Mobile Mechanic, please review and accept our Terms of Service and Repair Authorization: ${agreementLink(lead.id)}`;
  return smsHref(lead.phone, msg);
};

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const fmtDateOnly = (d) => {
  try {
    return new Date(`${d}T12:00:00`).toLocaleDateString("en-US", {
      weekday: "short", month: "short", day: "numeric",
    });
  } catch {
    return d;
  }
};

export const fmtTime12 = (t) => {
  try {
    const [h, m] = t.split(":");
    const d = new Date();
    d.setHours(Number(h), Number(m));
    return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  } catch {
    return t;
  }
};

const pad = (n) => String(n).padStart(2, "0");
const fmtG = (d) =>
  `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;

export const gcalLink = (appt) => {
  const start = new Date(`${appt.date}T${appt.start_time}:00`);
  const end = new Date(start.getTime() + (appt.duration_minutes || 60) * 60000);
  const details = `Phone: ${appt.phone}${appt.technician_name ? `\nTech: ${appt.technician_name}` : ""}${appt.notes ? `\nNotes: ${appt.notes}` : ""}`;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `${appt.service_type} — ${appt.name}`,
    dates: `${fmtG(start)}/${fmtG(end)}`,
    details,
    location: appt.address || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};
